import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Eyebrow, Reveal } from "../Reveal";
import { ADDRESS, IMAGES } from "../../data/site";

export const Edmonton = () => (
  <section data-testid="edmonton-section" className="section-pad bg-warm2">
    <div className="container-cando grid items-center gap-14 lg:grid-cols-12">
      <div className="order-2 lg:order-1 lg:col-span-6">
        <Reveal className="relative">
          <div className="overflow-hidden">
            <img
              src={IMAGES.edmonton}
              alt="Edmonton residential home"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              data-testid="edmonton-image"
            />
          </div>
          <div className="absolute -bottom-6 right-0 flex items-center gap-3 bg-charcoal px-6 py-4">
            <MapPin size={16} className="text-bronze" />
            <span className="font-heading text-[12px] font-bold uppercase tracking-[0.2em] text-warm">
              Edmonton, Alberta
            </span>
          </div>
        </Reveal>
      </div>

      <div className="order-1 lg:order-2 lg:col-span-6">
        <Reveal>
          <Eyebrow>Local &amp; Proud</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="h2 mt-6 max-w-md text-charcoal">Proudly Building in Edmonton.</h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="body-lg mt-7 max-w-xl text-mute">
            Cando Construction Services Ltd. works with homeowners throughout Edmonton on renovations,
            additions, framing and residential improvement projects.
          </p>
          <p className="mt-6 flex items-start gap-3 text-[15px] text-mute">
            <MapPin size={17} className="mt-0.5 shrink-0 text-bronze" />
            <span data-testid="edmonton-address">{ADDRESS}</span>
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <Link to="/contact" data-testid="edmonton-cta" className="link-arrow group mt-9">
            Discuss Your Project
            <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
